import React, { useEffect, useState, useCallback, useMemo } from "react";
import * as Sentry from "@sentry/react";
import { usePlaidLink } from "react-plaid-link";

import {
  createProviderLinkOnFailure,
  createProviderLinkOnClose,
  createProviderLinkOnSuccess,
} from "../../helpers/webViewCallback";

import { callBackendAPI } from "../../helpers/api";
import { useSearchParams } from "react-router-dom";
import darkTheme from "../../theme/theme.dark";
import lightTheme from "../../theme/theme.light";
import { ThemeProvider } from "@mui/material/styles";
import { Box, Paper, Button, CssBaseline, GlobalStyles } from "@mui/material";

const PlaidOauthCallback = ({}) => {
  const [searchParams] = useSearchParams();
  // const [isLoading, setIsLoading] = useState(true);
  const [providerInfo, setProviderInfo] = useState(null);
  const [providerId, setProviderId] = useState("");
  const [token, setToken] = useState("");
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [linkTokenData, setLinkTokenData] = useState(null);
  // const [oAuthStateId, setOAuthStateId] = useState(null);

  useEffect(() => {
    window.analytics.track("provider_link_plaid_oauth_page_view");
  }, []);

  useEffect(() => {
    const res =
      searchParams.get("providerId") || localStorage.getItem("providerId");
    setProviderId(res);
    localStorage.setItem("providerId", res);

    const linkTokenResp = JSON.parse(localStorage.getItem("plaid_link_token"));
    setLinkTokenData(linkTokenResp);

    const providerInfoResp = JSON.parse(localStorage.getItem("provider_info"));
    setProviderInfo(providerInfoResp);

    const res1 =
      searchParams.get("token") || localStorage.getItem("api_token") || "";
    localStorage.setItem("api_token", res1);
    setToken(res1);

    if (
      localStorage.getItem("user") &&
      localStorage.getItem("user") !== undefined
    ) {
      !user && setUser(JSON.parse(localStorage.getItem("user")));
    }

    if (res1) {
      fetchUserProfile();
    }
  }, []);

  const fetchUserProfile = async () => {
    try {
      const userProfileResp = await callBackendAPI({
        path: `/web/users/me`,
        method: "GET",
      });

      setUser(userProfileResp);
      localStorage.setItem("user", JSON.stringify(userProfileResp));
      window.analytics.identify(userProfileResp.id, {
        email: userProfileResp.email,
        platform: "providerLink",
        providerInfo,
      });
    } catch (err) {
      console.log(err);
    }
  };

  const mode = searchParams.get("mode");
  const walletId = searchParams.get("walletId");
  const redirectURL =
    searchParams.get("redirect") || localStorage.getItem("redirect");
  //web or mobile - to perform different actions for future
  const source = searchParams.get("source") || localStorage.getItem("source");

  localStorage.setItem("redirect", redirectURL);

  // localStorage.setItem("providerId", providerId);
  localStorage.setItem("source", source);

  const themeMemo = useMemo(() => {
    const theme = searchParams.get("theme") || localStorage.getItem("theme");
    localStorage.setItem("theme", theme);
    return theme === "dark" ? darkTheme : lightTheme;
  }, [searchParams]);

  const onSuccess = useCallback(async (public_token, metadata) => {
    // TODO - handle type here
    const linkTokenResp = JSON.parse(localStorage.getItem("plaid_link_token"));
    setLinkTokenData(linkTokenResp);
    const providerInfoResp = JSON.parse(localStorage.getItem("provider_info"));
    setProviderInfo(providerInfoResp);
    if (linkTokenData?.link_id) {
      const createItemRes = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/provider_link/fix_link`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("api_token")}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            link_id: linkTokenResp?.link_id,
            link_type: providerInfoResp.wallet_type,
            public_token: public_token,
            link_token: linkTokenResp?.link_token,
          }),
        }
      );
      const data = await createItemRes.json();

      window.analytics.track(
        "provider_link_fix_success",
        {
          source: "plaid_oauth_callback",
          target: "providerLink",
          link_id: linkTokenResp?.link_id,
          providerInfo: providerInfoResp,
        }
      );

      createProviderLinkOnSuccess({
        message: "Account fixed successfully",
      });
    } else {
      const createItemRes = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/provider_link/create_link`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("api_token")}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            link_type: providerInfoResp.wallet_type,
            provider_id: providerInfoResp.id,
            public_token: public_token,
            subtype: "",
            address: "",
            access_token: "",
          }),
        }
      );
      const data = await createItemRes.json();

      if (data && data.user_wallet_id) {
        createProviderLinkOnSuccess({
          message: "Account created successfully",
          walletId: data.user_wallet_id,
        });
        window.analytics.track(
          "provider_link_success",
          {
            source: "plaid_oauth_callback_account_create",
            target: "providerLink",
            walletId: data.user_wallet_id,
            providerInfoResp,
          }
        );
      }
    }
  }, []);

  // const generateToken = async () => {
  //   //TODO: add cutomisation of link type
  //   setIsLoading(true);
  //   const createLinkTokenRes = await callBackendAPI({
  //     path: `/provider_link/plaid/create_link_token?provider_id=${providerInfo.id}`,
  //     method: "GET",
  //   });

  //   setLinkTokenData(createLinkTokenRes);
  //   console.log({ createLinkTokenRes });
  // };

  // const generateRefreshToken = async () => {
  //   //TODO: add cutomisation of link type
  //   setIsLoading(true);
  //   // const walletId = localStorage.getItem("api_token")
  //   const createLinkTokenRes = await callBackendAPI({
  //     path: `/provider_link/plaid/create_refresh_link_token`,
  //     method: "POST",
  //     body: {
  //       user_wallet_id: walletId,
  //     },
  //   });

  //   setLinkTokenData(createLinkTokenRes);
  //   console.log({ createLinkTokenRes }, "refresh");
  // };

  // useEffect(() => {
  //   if (!isLoading) {
  //     if (mode === "fix") {
  //       window.analytics.track(
  //         "provider_link_plaid_provider_generate_refresh_token",
  //         {
  //           target: "providerLink",
  //           mode,
  //         }
  //       );
  //       generateRefreshToken();
  //     } else {
  //       window.analytics.track("provider_link_plaid_provider_generate_token", {
  //         target: "providerLink",
  //         mode,
  //       });
  //       generateToken();
  //     }
  //   }
  // }, [isLoading, mode]);

  // console.log("Plaid link token: ", localStorage.getItem("plaid_link_token"));

  const config = {
    token: linkTokenData?.link_token,
    receivedRedirectUri: window.location.href, //the redirect URI with an OAuth state ID parameter
    onSuccess,
    onEvent: async (eventName, metaData) => {
      console.log(eventName, metaData);

      if (eventName === "ERROR") {
        console.log(linkTokenData);
        window.analytics.track("provider_link_plaid_provider_report_error", {
          target: "providerLink",
          providerInfo: providerInfo,
          eventName,
          metaData,
        });
        const sendError = await callBackendAPI({
          path: `/provider_link/plaid/report_error?provider_id=${providerInfo.id}`,
          method: "POST",
          body: {
            link_token: linkTokenData?.link_token,
            error_data: {
              ...metaData,
            },
          },
        });
      }
    },
    onExit: useCallback(async (err, metadata) => {
      console.log({ err }, { metadata });
      Sentry.captureException(metadata);
      if (err) {
        if (err.error_code === "OAUTH_STATE_ID_ALREADY_PROCESSED") {
          createProviderLinkOnSuccess({
            message: "Account created successfully",
          });
          window.analytics.track(
            "provider_link_success",
            {
              source: "plaid_provider_oauth_callback_account_create",
              target: "providerLink",
              providerInfo,
            }
          );
        } else {
          Sentry.captureException(err);
          createProviderLinkOnFailure(
            "Something went wrong, please contact support"
          );
          window.analytics.track("provider_link_failure", {
            source: "plaid_oauth_callback",
            action: "failure",
            target: "providerLink",
            providerInfo,
            err,
            metadata,
          });
        }
      } else {
        createProviderLinkOnClose("Couldn't connect account, please try again");
        window.analytics.track("provider_link_failure", {
          source: "plaid_oauth_callback",
          action: "exit",
          target: "providerLink",
          message: "Couldn't connect account, please try again",
        });
      }
    }),
  };

  const { open, ready } = usePlaidLink(config);

  if (ready) {
    open();
  }
  return (
    <ThemeProvider theme={themeMemo}>
      <CssBaseline />
      <Box className="App">
        <div>Plaid oAuth in Progress</div>
      </Box>
    </ThemeProvider>
  );
};

export default PlaidOauthCallback;
